<div class="opted-in-container">
  <div class="left">
    @if (customer.customerName) {
      <h3>{{customer.customerName}}</h3>
    }
    @if (optInData.optInDate) {
      <p class="opted-in-date">Opted in on {{optInData.optInDate | date:'shortDate'}}</p>
    }
  </div>
  <div class="right">
    <address>
      @if (customer.addr1) {
        <span>{{customer.addr1}}<br/></span>
      }
      @if (customer.addr2) {
        <span>{{customer.addr2}}<br/></span>
      }
      @if (customer.addr3) {
        <span>{{customer.addr3}}<br/></span>
      }
      @if (customer.city) {
        <span>{{customer.city}}</span>
        }, @if (customer.state) {
        <span>{{customer.state}}</span>
        }  @if (customer.postalCode) {
        <span>{{customer.postalCode}}</span>
        }<br />
        @if (customer.phone) {
          <span>{{customer.phone}}</span>
        }
      </address>
      <div class="opt-out">
        <button class="opt-out-btn" (click)="optOut()">Opt Out</button>
      </div>
      <div class="modify-status">
        <button class="modify-status-btn" (click)="modifyEyefinityStatus()">Modify Eyefinity Status</button>
      </div>
    </div>
  </div>

  @if(cantFindBusinessAccounts){
    <div class="cant-find-business-accounts">
      <p class="error">Sorry, we can't find any business accounts with Eyefinity Account Number's.</p>
    </div>
  }

  @if (businessAccounts.length > 0) {
    <div class="business-accounts">
      <ul>
        <li class="business-accounts-header">
          <h3>EFAN Numbers</h3>
          <span>enable</span>
          <span>disable</span>
        </li>
        @for (account of businessAccounts; track account; let i = $index) {
          <li class="efan-number">
            <span>{{account.eyefinityAccountNumber}} - {{account.street}}</span> <!-- {{account.accountName}} -->
            <input type="radio" id="enable-{{account.eyefinityAccountNumber}}" (change)="updateEFANStatus(i, true)" [checked]="statusE[i]" name="{{account.eyefinityAccountNumber}}">
            <input type="radio" id="disable-{{account.eyefinityAccountNumber}}" (change)="updateEFANStatus(i, false)" [checked]="statusD[i]" name="{{account.eyefinityAccountNumber}}">
          </li>
        }
      </ul>
      <div class="btn-group">
        <button class="updateBA-btn" (click)="saveEFANStatus()">Update</button>
        <button class="resetBA-btn" (click)="resetStatus()">Reset</button>
      </div>
    </div>
  }